export default [

     {
          path: '/audit-assessment-actions-result',
          name: 'AuditAssessmentActionsResult',
          component: () => import("@/views/Page/AuditAssessmentActionsResult/AuditAssessmentActionsResult.vue"),
           meta: {
               title: '#Default# | AuditAssessmentActionsResult',
          },
     }
];